var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pc-basket-sidebar-section" }, [
    !_vm.confirmationPage
      ? _c("div", { staticClass: "pc-basket-sidebar-main-heading" }, [
          _c("h5", { staticClass: "primary-heading" }, [
            _vm._v(
              _vm._s(_vm.$resourceString["myBasket.Label.TotalBasketItems"])
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "pc-basket-sidebar-details-btn" }, [
      _vm.individualSamples ||
      _vm.projectSamples ||
      _vm.designTraySample ||
      _vm.confirmationPage
        ? _c("div", { staticClass: "pc-basket-sidebar-details" }, [
            _vm.individualSamples
              ? _c("div", { staticClass: "pc-basket-sidebar-list" }, [
                  _c("h5", { staticClass: "primary-heading" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$resourceString["myBasket.Sidebar.Label.Samples"]
                      ) + ": "
                    ),
                    _c("span", [_vm._v(_vm._s(_vm.individualSamplesCount))])
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.projectSamples
              ? _c("div", { staticClass: "pc-basket-sidebar-list" }, [
                  _c("h5", { staticClass: "primary-heading" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$resourceString[
                          "myBasket.Sidebar.Label.ProjectSamples"
                        ]
                      ) + ": "
                    ),
                    _c("span", [_vm._v(_vm._s(_vm.projectSamplesCount))])
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.designTraySample
              ? _c("div", { staticClass: "pc-basket-sidebar-list" }, [
                  _c("h5", { staticClass: "primary-heading" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$resourceString[
                          "myBasket.Sidebar.Label.DesignTrays"
                        ]
                      ) + ": "
                    ),
                    _c("span", [_vm._v(_vm._s(_vm.designTraySampleCount))])
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.confirmationPage
              ? _c("div", { staticClass: "pc-basket-sidebar-list" }, [
                  _c("h5", { staticClass: "primary-heading" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$resourceString[
                          "myBasket.Sidebar.Label.NeedToOrderYourOtherSamples"
                        ]
                      )
                    )
                  ])
                ])
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "pc-basket-sidebar-btn" }, [
        !!_vm.backLabel
          ? _c(
              "button",
              {
                staticClass: "btn btn-white back-btn border-dark",
                attrs: { type: "button" },
                on: { click: _vm.backAction }
              },
              [
                _c("span", {
                  staticClass: "png-icon png-icon-icons-glyph--k-arrow-back"
                }),
                _vm._v(" "),
                _c("span", { staticClass: "btn-label" }, [
                  _vm._v(_vm._s(_vm.backLabel))
                ])
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        !!_vm.nextLabel
          ? _c(
              "button",
              {
                staticClass: "btn btn-primary next-btn",
                attrs: { disabled: _vm.isNextDisabled, type: "button" },
                on: { click: _vm.nextAction }
              },
              [
                _c("span", { staticClass: "btn-label" }, [
                  _vm._v(_vm._s(_vm.nextLabel))
                ]),
                _vm._v(" "),
                _c("span", {
                  staticClass: "png-icon png-icon-icons-glyph--ko-arrow-next"
                })
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        !!_vm.exploreButtonOneLabel
          ? _c(
              "button",
              {
                staticClass:
                  "btn btn-white back-btn border-dark next-btn explore-btn-1",
                attrs: { type: "button" },
                on: { click: _vm.exploreButtonOneAction }
              },
              [
                _c("span", { staticClass: "btn-label" }, [
                  _vm._v(_vm._s(_vm.exploreButtonOneLabel))
                ]),
                _vm._v(" "),
                _c("span", {
                  staticClass: "png-icon png-icon-icons-glyph--k-arrow-next"
                })
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        !!_vm.exploreButtonTwoLabel
          ? _c(
              "button",
              {
                staticClass:
                  "btn btn-white back-btn border-dark next-btn explore-btn-2",
                attrs: { type: "button" },
                on: { click: _vm.exploreButtonTwoAction }
              },
              [
                _c("span", { staticClass: "btn-label" }, [
                  _vm._v(_vm._s(_vm.exploreButtonTwoLabel))
                ]),
                _vm._v(" "),
                _c("span", {
                  staticClass: "png-icon png-icon-icons-glyph--k-arrow-next"
                })
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isError && _vm.errorMsg
          ? _c("div", {
              staticClass: "field-validation-error text-secondary mt-2",
              domProps: { innerHTML: _vm._s(_vm.errorMsg) }
            })
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }